import {
  ArrayInput,
  FormTab,
  TabbedForm,
  TabbedFormProps,
  ReferenceInput,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  required,
  BooleanInput
} from 'react-admin';
import { UploadImageInput } from '../../components';
import UploadInput from '../../components/UploadInput';

export default function ProductsForm(props: Partial<TabbedFormProps>) {
  return (
    <TabbedForm {...props} redirect="list">
      <FormTab label="Dados básicos">
        <TextInput
          autoComplete="off"
          fullWidth
          label="Nome"
          source="name"
          validate={[required()]}
        />

        <ReferenceInput
          fullWidth
          label="Marca"
          sort={{ field: 'name', order: 'ASC' }}
          perPage={-1}
          source="brand"
          reference="brands"
          validate={[required()]}
        >
          <SelectInput />
        </ReferenceInput>

        <UploadImageInput
          fullWidth
          helperText="É possível enviar imagens no formato PNG com dimensões recomendadas de 168x288px."
          label="Imagem"
          upploadOptions={{
            maxSize: [168, 288]
          }}
          mimeTypes={['image/png', 'image/jpeg']}
          source="image"
          validate={[required()]}
        />

        <TextInput
          autoComplete="off"
          fullWidth
          label="Ingredientes"
          source="ingredients"
          validate={[required()]}
        />

        <UploadImageInput
          effects={[]}
          fullWidth
          helperText="É possível enviar imagens no formato JPEG."
          label="Tabela nutricional"
          mimeTypes={['image/png', 'image/jpeg']}
          source="nutritionTable"
          validate={[required()]}
        />
        <BooleanInput label="Ativo" source="active" defaultValue />
      </FormTab>

      <FormTab label="Embalagem">
        <ArrayInput label="Embalagem" source="packaging">
          <SimpleFormIterator>
            <TextInput
              autoComplete="off"
              fullWidth
              label="Link para compra"
              source="link"
            />

            <UploadImageInput
              fullWidth
              helperText="É possível enviar imagens no formato PNG com dimensões recomendadas de 168x288px."
              label="Foto"
              upploadOptions={{
                maxSize: [168, 288]
              }}
              mimeTypes={['image/png', 'image/jpeg']}
              source="photo"
              validate={[required()]}
            />

            <UploadInput
              fullWidth
              helperText="É possível enviar imagens no formato SVG."
              label="Ícone"
              mimeTypes={['.svg']}
              source="icon"
              validate={[required()]}
            />

            <TextInput
              autoComplete="off"
              fullWidth
              label="Litragem"
              source="volume"
              validate={[required()]}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  );
}
